module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOCAMAAAB5Au6AAAAAD1BMVEX///9aOSnOKRiEe3P3hCF0sVY2AAAAAXRSTlMAQObYZgAAAFdJREFUKM+djkEKACEMA2My/3/zHjy0SvGwAUshIx2JZyT8DKqVe9q2CwiwKyAD4NTl6jtQROvdHXr+AEmdyCjp4f8BAMl+zJKJA3HSHVY53NO2l7Se0QdGZARtO6iWKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/categories/Physical.png
// module id = 175
// module chunks = 0